import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { FC } from 'react'
import PrimaryButton from '@organisms/PrimaryButton'
import Modal from '@organisms/Modal'
import {
  getDangerHazardName,
  getEventName,
} from '@modals/RiskMapModal/Dangers/nameUtils'
import useMe from '@hooks/useMe'
import useHasJobs from '@hooks/useHasJobs'
import { useAppSelector } from '@hooks/useAppSelector'
import useMeresModal from './useMeresModal'
import MeresFields from './MeresFields'

type Props = {
  index: number
}

const DangersFieldsMeresModalButton: FC<Props> = ({ index }) => {
  const { company: meCompany } = useMe()
  const { hasCompany } = useHasJobs()

  const methods = useFormContext()
  const { watch } = methods

  const meresIsVisibleIndex = useAppSelector(
    (state) => state.riskMapModal.meresIsVisibleIndex
  )

  const { openMeres, closeMeres, meresIsLoading } = useMeresModal(
    methods,
    index
  )

  const hazard = watch(getDangerHazardName(index))
  const event = watch(getEventName(index))

  const company = hasCompany ? watch('company') : meCompany

  return (
    <>
      <PrimaryButton
        disabled={!hazard || !event}
        onClick={openMeres}
        id="risk-map-danger-fill-meres"
        isLoading={meresIsLoading}
      >
        Заполнить меры
      </PrimaryButton>
      <Modal
        visible={meresIsVisibleIndex === index}
        onModalClose={closeMeres}
        withoutCloseOnOutsideClick
      >
        <MeresFields
          hazard={hazard}
          event={event}
          dangerousIndex={index}
          onModalClose={closeMeres}
          company={company}
        />
      </Modal>
    </>
  )
}

export default DangersFieldsMeresModalButton
